export default [
    {
        image: '/static/images/slider-2.jpg',
        heading: '¡✨ Que tu negocio no se detenga!',
        subHeading: 'Acelera tus procesos con nuestras soluciones de fácil uso ¡No te detengas!',
    },
    {
        image: '/static/images/slider-1.jpg',
        heading: '¡👉 Una herramienta para crecer!',
        subHeading: 'Reduce en un 85% tus gastos de facturación y administrativos',
    },
    {
        image: '/static/images/slider-3.jpg',
        heading: '¡⚡ Trabaja mejor y más rápido!',
        subHeading: 'Obtén la tranquilidad que necesitas, utilizando nuestras soluciones integrales',
    },
];
